import { Flex, Box, Text } from '@chakra-ui/react';

export const Metrics = ({ blueprint = {} }) => {
  return (
    <Box>
      <Flex
        h="80px"
        borderBottomWidth="1px"
        justifyContent="center"
        alignItems="center"
      >
        <Text fontSize="16px" fontWeight="semiBold">
          Metrics
        </Text>
      </Flex>
      <Box h="80px" textAlign="center" mt="24px">
        <Text fontSize="16px" fontWeight="semiBold">
          {blueprint?.stats?.sent_count}
        </Text>
        <Text variant="muted">Sent</Text>
      </Box>
      <Box h="80px" mb="32px" textAlign="center">
        <Text fontSize="16px" fontWeight="semiBold">
          {blueprint?.stats?.interested_count}
        </Text>
        <Text variant="muted">Interested</Text>
      </Box>
      <Box h="80px" mb="32px" textAlign="center">
        <Text fontSize="16px" fontWeight="semiBold">
          {blueprint?.stats?.open_rate}%
        </Text>
        <Text variant="muted">Opened</Text>
      </Box>
      <Box h="80px" mb="32px" textAlign="center">
        <Text fontSize="16px" fontWeight="semiBold">
          {blueprint?.stats?.reply_rate} %
        </Text>
        <Text variant="muted">Replied</Text>
      </Box>
    </Box>
  );
};
